import Root from './Root'
import List from './List'
import Trigger from './Trigger'
import Content from './Content'

export const Tabs = { Root, List, Content, Trigger }

export default Tabs
